var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container"},[_c('div',{attrs:{"id":"div-h1"}},[_c('h1',[_vm._v("Botiga")])]),_vm._v(" "),_c('div',{attrs:{"id":"txt-descripcio"}},[_c('p',[_vm._v("\n\t\t\tProperament\n\t\t")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e059c26","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Botiga.vue
// module id = 275
// module chunks = 0